// extracted by mini-css-extract-plugin
export default {"container":"InfoModal_container_SxhDH","content":"InfoModal_content_e6T8N"};